/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Bento_SubInputs */

const en_nfp_bento_sub = /** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign tools designed to unify your mission without the monthly overhead of legacy enterprise software.`)
};

const es_nfp_bento_sub = /** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas diseñadas para unificar tu misión sin los gastos generales mensuales de software antiguo.`)
};

const fr_nfp_bento_sub = /** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des outils souverains conçus pour unifier votre mission sans les frais généraux mensuels des anciens logiciels d'entreprise.`)
};

const de_nfp_bento_sub = /** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souveräne Werkzeuge, die entwickelt wurden, um deine Mission ohne die monatlichen Fixkosten veralteter Enterprise-Software zu vereinen.`)
};

const id_nfp_bento_sub = /** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alat sovereign yang dirancang untuk menyatukan misi Anda tanpa biaya bulanan dari perangkat lunak perusahaan lama.`)
};

/** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */
const ja_nfp_bento_sub = en_nfp_bento_sub;

/** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */
const zh_nfp_bento_sub = en_nfp_bento_sub;

/** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */
const ar_nfp_bento_sub = en_nfp_bento_sub;

/** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */
const it_nfp_bento_sub = en_nfp_bento_sub;

/** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */
const ru_nfp_bento_sub = en_nfp_bento_sub;

/** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */
const pt_nfp_bento_sub = en_nfp_bento_sub;

/** @type {(inputs: Nfp_Bento_SubInputs) => LocalizedString} */
const ko_nfp_bento_sub = en_nfp_bento_sub;

/**
* | output |
* | --- |
* | "Sovereign tools designed to unify your mission without the monthly overhead of legacy enterprise software." |
*
* @param {Nfp_Bento_SubInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_bento_sub = /** @type {((inputs?: Nfp_Bento_SubInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Bento_SubInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_bento_sub(inputs)
	if (locale === "es") return es_nfp_bento_sub(inputs)
	if (locale === "fr") return fr_nfp_bento_sub(inputs)
	if (locale === "de") return de_nfp_bento_sub(inputs)
	if (locale === "ja") return ja_nfp_bento_sub(inputs)
	if (locale === "zh") return zh_nfp_bento_sub(inputs)
	if (locale === "ar") return ar_nfp_bento_sub(inputs)
	if (locale === "id") return id_nfp_bento_sub(inputs)
	if (locale === "it") return it_nfp_bento_sub(inputs)
	if (locale === "ru") return ru_nfp_bento_sub(inputs)
	if (locale === "pt") return pt_nfp_bento_sub(inputs)
	return ko_nfp_bento_sub(inputs)
});